var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariation = void 0;
const react_1 = __importDefault(require("react"));
const VariationNotFound = (props) => (react_1.default.createElement("div", null,
    "Variation \"",
    props.variation,
    "\" not found"));
const VariationPropNotFound = () => (react_1.default.createElement("div", null, "Property 'props.variation' not found"));
exports.getVariation = (props, variations) => {
    if ('variation' in props) {
        if (!variations[props.variation]) {
            return VariationNotFound;
        }
        const Variation = variations[props.variation];
        return Variation;
    }
    if ('single' in variations) {
        const Variation = variations.single;
        return Variation;
    }
    return VariationPropNotFound;
};
//# sourceMappingURL=get-variation.js.map